
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/[customerId]/onboarding",
      function () {
        return require("private-next-pages/d/[customerId]/onboarding.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/[customerId]/onboarding"])
      });
    }
  